import { render, staticRenderFns } from "./Querstiondetails.vue?vue&type=template&id=5fa48596&scoped=true&"
import script from "./Querstiondetails.vue?vue&type=script&lang=js&"
export * from "./Querstiondetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa48596",
  null
  
)

export default component.exports